import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CookieServiceService } from '../cookie-service.service';
import { HelperService } from '../helper.service';
import { UtilisService } from '../utilis.service';

@Component({
  selector: 'app-solchange',
  templateUrl: './solchange.component.html',
  styleUrls: ['./solchange.component.scss']
})
export class SolchangeComponent implements OnInit {
  IssueArr2: { old_sol: any; new_sol: number;reason1:any; };
  IssueArr1: { solid: any; };
  IssueArr3: { sol_id: any; };

  constructor(public helperService: HelperService, private router: Router, private ngZone: NgZone,
    private utilService: UtilisService,
    private spinner: NgxSpinnerService,
    private toast: ToastrService,
    private cookieService: CookieServiceService, private route: ActivatedRoute) {
    this.account_no = history.state.accountNumber;
    this.presentbrnch = history.state.branchname;
    this.sol = history.state.solid;
  }

  selectedsol: any;
  reason:any;
  account_no: any;
  presentbrnch: any;
  sol: any;
  sol_list: any;
  txtcheckbox: any;
  terms: any;
  update_response: any;
  isDisabled: Boolean = true;
  serviceType: any = "beforeResponse";
  servicemsg: any = "beforeResponse";
  label_class: any = "";
  SchemeHref: any;
  changesolfunc() {
    try {
      this.IssueArr2 = ({
        old_sol: this.utilService.Encryptdata(this.sol),
        new_sol: this.utilService.Encryptdata(this.selectedsol),
        reason1: this.utilService.Encryptdata(this.reason)
      })
      this.spinner.show();
      this.helperService.makePostRequest(this.IssueArr2, "/changeSOL").subscribe(res => {
        this.spinner.hide();
        this.serviceType = "afterResponse";
        this.label_class = "text-success";
        this.update_response = this.utilService.Decryptdata(res.status);
      });
    }
    catch (Error) {
      this.serviceType = "afterResponse";
      this.label_class = "text-success";
      this.update_response = "Unable To Process your request. Please Visit nearest branch.";
    }
  }
  getBranchdtls() {
    try {
      this.account_no = (this.account_no ? this.account_no + "" : "");
      this.presentbrnch = (this.presentbrnch ? this.presentbrnch + "" : "");
      this.sol = (this.sol ? this.sol + "" : "");
      if (this.account_no && this.presentbrnch && this.sol) {
        this.IssueArr1 = ({
          solid: this.sol
        })
        this.spinner.show();
        this.helperService.makePostRequest(this.IssueArr1, "/getSOL").subscribe(res => {
          this.spinner.hide();
          this.sol_list = res;
        });
      }
      else {
        this.cookieService.clearTokenCookie();
      }
    }
    catch (Error) {
      this.spinner.hide();
      this.toast.error("Server Error Occured", "", {
        positionClass: 'toast-bottom-right'
      });
      this.cookieService.clearTokenCookie();
    }
  }
  goToLink() {
    window.open(this.SchemeHref, "_blank");
  }

  ngOnInit(): void {
    this.getBranchdtls();
  }
  getCustConfirmMsg() {
    if (!this.selectedsol || this.selectedsol.length == 0) {
      this.toast.error("New Branch Name cannot be empty", "", {
        positionClass: 'toast-bottom-right'
      });
    }
    else {
      try {
        this.IssueArr3 = ({
          sol_id: this.selectedsol
        })
        this.spinner.show();
        this.helperService.makePostRequest(this.IssueArr3, "/getCustomermsg").subscribe(res => {
          this.spinner.hide();
          this.servicemsg = "afterResponse";
          this.terms = res.message1;
          this.SchemeHref = res.message2;
        });
      }
      catch (Error) {
        this.spinner.hide();
        this.toast.error("Server Error Occured", "", {
          positionClass: 'toast-bottom-right'
        });
        this.cookieService.clearTokenCookie();
      }
    }
  }
  disableGenerateButton() {
    this.selectedsol = (this.selectedsol ? this.selectedsol + "" : "");
    this.reason = (this.reason ? this.reason + "" : "");
    if (this.txtcheckbox && this.selectedsol && this.reason && this.reason.length > 0) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }
}
